<nb-card>
  <nb-card-header [translate]="title" [translateParams]="translateParams"></nb-card-header>
  <nb-card-body>
    <p class="message" [translate]="message" [translateParams]="translateParams"></p>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="button"
      nbButton
      [status]="confirmStatus"
      (click)="confirm()"
      [translate]="confirmText"
      [translateParams]="translateParams"
    ></button>
    <button *ngIf="cancelText != undefined && cancelText != null" type="button" class="button_cancel" nbButton status="info" (click)="cancel()" [translate]="cancelText" [translateParams]="translateParams"></button>
  </nb-card-footer>
</nb-card>
